var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoadingRobotLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 166.731,
    height: 329,
    viewBox: "0 0 166.731 329",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -1.343,
    y1: -0.608,
    x2: 1.086,
    y2: -0.199,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2581c4",
    stopOpacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_476",
    "data-name": "Group 476",
    transform: "translate(-104 -328)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_137",
    "data-name": "Ellipse 137",
    cx: 81.5,
    cy: 7.5,
    rx: 81.5,
    ry: 7.5,
    transform: "translate(104 642)",
    fill: "#707070",
    opacity: 0.18
  }), /*#__PURE__*/React.createElement("g", {
    id: "Infinity_3",
    "data-name": "Infinity 3",
    transform: "translate(-52.297 293.105)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1401",
    "data-name": "Path 1401",
    d: "M322.83,363.861q-.176,2.392-.493,4.761a79.3,79.3,0,0,1-1.99,9.866,81.86,81.86,0,0,1-5.359,14.364,84.82,84.82,0,0,1-6.547,11.278,86.56,86.56,0,0,1-30.948,27.606q-3.479,1.836-7.156,3.339a81.264,81.264,0,0,1-60.3.539c-.551-.216-1.1-.439-1.645-.668q-2.78-1.153-5.435-2.506c-.553-.282-1.1-.563-1.638-.857-.088-.046-.176-.1-.263-.143a85.4,85.4,0,0,1-31.308-29.532c-.239-.383-.478-.765-.717-1.155a87.956,87.956,0,0,1-5.347-10.171c-.191-.418-.375-.836-.553-1.26a86.706,86.706,0,0,1-4.106-11.971A81.587,81.587,0,0,1,157,367.113a77.972,77.972,0,0,1-.53-15.488,73.587,73.587,0,0,1,3.15-16.952,85.668,85.668,0,0,1,18.432-31.682v-.007a106.616,106.616,0,0,1,9.61-9.41,94.647,94.647,0,0,1,13.2-9.681l.079-.014c.219-.049.438-.1.656-.141a184.049,184.049,0,0,1,69.884-1.1q2.23.389,4.327.814c.007,0,.012.007.019.008.5.1,1,.2,1.49.3.077.019.148.031.224.049q1.849,1.055,3.634,2.184c.206.126.4.258.6.39a93.425,93.425,0,0,1,20.933,18.339v.007a89.965,89.965,0,0,1,5.664,7.444c.982,1.441,1.924,2.912,2.812,4.4q.9,1.484,1.721,3a84.088,84.088,0,0,1,7.132,17.454,77.88,77.88,0,0,1,2,9.078,76.832,76.832,0,0,1,.787,17.756Z",
    transform: "translate(0 -85.693)",
    fill: "#e9f0fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1402",
    "data-name": "Path 1402",
    d: "M304.044,287.3a1.972,1.972,0,0,1-.473,1.2c-.793,1.037-2.605,2-5.23,2.862-.014.005-.033.01-.047.016a62.9,62.9,0,0,1-9.205,2.048c-.251.04-.5.081-.759.12a174.771,174.771,0,0,1-26.146,1.59c-4.163-.026-8.188-.179-11.982-.432h-.007c-12.495-.822-22.523-2.739-27.079-5.134-.2-.106-.388-.218-.57-.322a4.155,4.155,0,0,1-2.018-2.078,1.711,1.711,0,0,1-.08-.508,1.967,1.967,0,0,1,.057-.419,1.767,1.767,0,0,1,.167-.412,3.574,3.574,0,0,1,1.091-1.185c.131-.095.268-.189.406-.289a.2.2,0,0,0,.048-.029,13.231,13.231,0,0,1,1.823-.941c6.517-2.806,21.2-4.692,38.269-4.565,13.871.1,26.159,1.513,33.743,3.6a.021.021,0,0,1,.019.008c.78.214,1.506.437,2.181.662.007,0,.012.007.019.008,3.034,1.025,5,2.18,5.584,3.4a1.8,1.8,0,0,1,.19.79Z",
    transform: "translate(-22.445 -85.346)",
    fill: "#aeb7c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1403",
    "data-name": "Path 1403",
    d: "M194.469,326.542A153.42,153.42,0,0,0,176.318,359.3,27.582,27.582,0,0,1,161.4,347.144a85.668,85.668,0,0,1,18.432-31.682,24.07,24.07,0,0,0,14.64,11.08Z",
    transform: "translate(-1.784 -98.165)",
    fill: "#aeb7c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1404",
    "data-name": "Path 1404",
    d: "M390.861,350.431a27.491,27.491,0,0,1-15.122,11.332,152.862,152.862,0,0,0-17.025-33.35,24.273,24.273,0,0,0,8.889-4.046,24,24,0,0,0,5.928-6.239,89.966,89.966,0,0,1,5.665,7.444c.982,1.441,1.924,2.912,2.812,4.4q.9,1.484,1.722,3a84.088,84.088,0,0,1,7.132,17.454Z",
    transform: "translate(-70.822 -99.098)",
    fill: "#aeb7c5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_522",
    "data-name": "Rectangle 522",
    width: 27.303,
    height: 19.502,
    rx: 6.711,
    transform: "translate(225.931 229.485) rotate(0.401)",
    fill: "#2eb3bd",
    opacity: 0.61
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_523",
    "data-name": "Rectangle 523",
    width: 6.867,
    height: 60.341,
    transform: "translate(236.142 249.04) rotate(0.645)",
    fill: "#2eb3bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1405",
    "data-name": "Path 1405",
    d: "M322.712,415.6a79.3,79.3,0,0,1-1.99,9.866,136.087,136.087,0,0,1-21.57,11.777c-.061.028-.121.05-.182.078-30.679,13.232-57.9,11.438-68.66,10.6a161.2,161.2,0,0,1-58.167-16.481c-4.924-2.455-9.2-4.907-12.743-7.11a81.584,81.584,0,0,1-2.03-10.241c2.133,1.4,4.6,2.933,7.359,4.537a161.932,161.932,0,0,0,57.638,20.315c4.794.672,9.329,1.064,13.5,1.279q3.625.178,6.863.185a133.14,133.14,0,0,0,18.66-1.1,143.825,143.825,0,0,0,39.735-11.653c3.864-1.756,7.859-3.77,11.926-6.071,3.775-2.134,7.017-4.2,9.664-5.977Z",
    transform: "translate(-0.376 -132.675)",
    fill: "#2eb3bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1406",
    "data-name": "Path 1406",
    d: "M212.369,494.561q-2.78-1.153-5.435-2.506c-.553-.282-1.1-.563-1.638-.857a77.48,77.48,0,0,0,1.32-11.122,8.086,8.086,0,0,0-1.259-5.21,7.913,7.913,0,0,0-3.049-2.415,7.048,7.048,0,0,0-1.6-.437,149.4,149.4,0,0,1-26.985-10.492c-.239-.383-.478-.765-.717-1.155a87.958,87.958,0,0,1-5.347-10.171c.187.112.387.231.581.343a166.886,166.886,0,0,0,38.568,16.272,8.8,8.8,0,0,1,1.783.49,9.627,9.627,0,0,1,6.17,9.7,78.863,78.863,0,0,1-2.393,17.555Z",
    transform: "translate(-3.976 -145.307)",
    fill: "#2eb3bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1407",
    "data-name": "Path 1407",
    d: "M375.321,453.691a84.823,84.823,0,0,1-6.547,11.278,149.685,149.685,0,0,1-25.882,9.426,6.862,6.862,0,0,0-1.608.416,7.974,7.974,0,0,0-3.093,2.354,8.116,8.116,0,0,0-1.341,5.194,78.408,78.408,0,0,0,.976,10.215q-3.479,1.836-7.155,3.339a78.568,78.568,0,0,1-1.916-16.764,9.631,9.631,0,0,1,6.332-9.6,8.837,8.837,0,0,1,1.794-.455,167.147,167.147,0,0,0,38.44-15.406Z",
    transform: "translate(-60.334 -146.529)",
    fill: "#2eb3bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1408",
    "data-name": "Path 1408",
    d: "M293.925,282.287c-8.508-.339-20.8,2.016-30.019,7.355a32.951,32.951,0,0,1-13.7,5.068H250.2a34.508,34.508,0,0,1-8.95-.359c-5.658-.716-13.931-2.478-18.129-4.775-.2-.106-.388-.218-.57-.322a4.436,4.436,0,0,1-2.018-2.078,1.71,1.71,0,0,1-.08-.508,1.965,1.965,0,0,1,.057-.419,2.146,2.146,0,0,1,.167-.411,3.954,3.954,0,0,1,1.091-1.185c.131-.095.268-.189.406-.289a.2.2,0,0,0,.048-.029c.371-.259.763-.531,1.167-.8.219-.049.438-.1.656-.141,6.517-2.806,21.2-4.692,38.269-4.564,13.871.1,26.159,1.513,33.743,3.6-.679-.07-1.386-.122-2.128-.144Z",
    transform: "translate(-22.446 -85.345)",
    fill: "#232952",
    opacity: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1409",
    "data-name": "Path 1409",
    d: "M373.092,367.184q-.176,2.392-.493,4.761a79.308,79.308,0,0,1-1.99,9.866,81.865,81.865,0,0,1-5.359,14.364,84.823,84.823,0,0,1-6.547,11.278,86.561,86.561,0,0,1-30.948,27.606q-3.479,1.836-7.156,3.339a80.955,80.955,0,0,1-20.648,5.443,116.745,116.745,0,0,0,16.174-9.671c9.721-6.925,21.7-15.464,29.255-31.452a64.27,64.27,0,0,0,3.476-9.053A67.5,67.5,0,0,0,351.008,384a96.84,96.84,0,0,0,.9-10.925,90.187,90.187,0,0,0-7.846-39.116c-3.035-6.505-8.5-17.871-20.732-27.307a64.288,64.288,0,0,0-14.811-8.537c1.368-.143,12.41-1.305,14.281-1.931a26.249,26.249,0,0,0,3.31-1.125c.014-.006.033-.01.047-.016a27.9,27.9,0,0,0,5.23-2.862,4.572,4.572,0,0,0,.283-1.993,2.623,2.623,0,0,0-.236-.871,93.682,93.682,0,0,1,21.536,18.729v.006a89.952,89.952,0,0,1,5.664,7.444c.982,1.441,1.924,2.912,2.812,4.4q.9,1.484,1.722,3a84.092,84.092,0,0,1,7.132,17.454,77.867,77.867,0,0,1,2,9.078,76.832,76.832,0,0,1,.787,17.756Z",
    transform: "translate(-50.262 -89.016)",
    fill: "#232952",
    opacity: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1410",
    "data-name": "Path 1410",
    d: "M201.057,438.845a85.4,85.4,0,0,1-31.308-29.532c-.239-.383-.478-.765-.717-1.155a87.956,87.956,0,0,1-5.347-10.171c-.191-.418-.375-.836-.553-1.26a86.707,86.707,0,0,1-4.106-11.971A81.584,81.584,0,0,1,157,374.517a77.972,77.972,0,0,1-.53-15.488,73.588,73.588,0,0,1,3.15-16.952A85.668,85.668,0,0,1,178.048,310.4v-.007a106.62,106.62,0,0,1,9.61-9.41c-1.64,2.448-3.435,5.223-5.31,8.292-5.669,9.277-12.064,19.732-15.918,31.28-.611,1.839-6.64,20.528-3.316,41.183,4.678,29.1,25.686,48.185,37.943,57.112Z",
    transform: "translate(0 -93.098)",
    fill: "#fff",
    opacity: 0.49
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1411",
    "data-name": "Path 1411",
    d: "M335.812,289.77a5.271,5.271,0,0,1-2.849,2.933.137.137,0,0,0-.041.023,38.966,38.966,0,0,1-6.17,2.251,46.978,46.978,0,0,1-15.456,2.038h-.013l-.039,0a90.952,90.952,0,0,0,9.167-2.5c6.554-2.158,9.856-3.278,10.84-5.578a5.185,5.185,0,0,0,.322-2.786c-.013-.086-.026-.178-.046-.27.077.019.148.031.224.049q1.849,1.055,3.634,2.184c.206.126.4.258.6.39a3.986,3.986,0,0,1-.178,1.271Z",
    transform: "translate(-54.213 -87.814)",
    fill: "#fff",
    opacity: 0.49
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1412",
    "data-name": "Path 1412",
    d: "M306.83,177.9a8.782,8.782,0,0,1-3.9,2.314,108.694,108.694,0,0,1-43.273,7.547q-1.337-.04-2.632-.115a108.265,108.265,0,0,1-27-5.037c-1.267-.413-2.469-.82-3.593-1.229a8.737,8.737,0,0,1-3.909-2.165,8.563,8.563,0,0,1-2.623-6.073L217.958,49.068a8.964,8.964,0,0,1,2.434-6.151,8.66,8.66,0,0,1,2.363-1.723,8.887,8.887,0,0,1,2.4-.789h.007a144.947,144.947,0,0,1,75.02-1.1c.077.012.167.032.263.052a8.754,8.754,0,0,1,2.9,1.178A8,8,0,0,1,304.7,41.6a9.006,9.006,0,0,1,2.63,6.073l1.936,124.077a9.057,9.057,0,0,1-2.435,6.157Z",
    transform: "translate(-21.574 -0.002)",
    fill: "#e9f0fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1413",
    "data-name": "Path 1413",
    d: "M306.154,156.875c-1.989.714-3.81,1.454-5.447,2.174a7.1,7.1,0,0,0-3.278,2.2,8.975,8.975,0,0,0-1.831,3.529,9.982,9.982,0,0,0-.339,2.569l-.031,4.411a76.873,76.873,0,0,1-43.878,3.37,79.9,79.9,0,0,1-9.153-2.557l-.426-5.188a10.041,10.041,0,0,0-.537-2.536,8.976,8.976,0,0,0-2.091-3.381,7,7,0,0,0-3.435-1.948c-1.474-.525-3.091-1.049-4.84-1.549L229.027,40.4h.007A144.863,144.863,0,0,1,298.439,38c1.991.413,3.862.851,5.615,1.293.077.012.167.032.263.052l1.838,117.525Z",
    transform: "translate(-25.447)",
    fill: "#353f44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1414",
    "data-name": "Path 1414",
    d: "M327.856,180.933a8.782,8.782,0,0,1-3.9,2.314,108.694,108.694,0,0,1-43.273,7.547q-1.337-.04-2.632-.115c19.909-3.379,34.43-7.069,39.863-9.851a13.492,13.492,0,0,0,6.209-5.625,13.118,13.118,0,0,0,1.171-8.03q-.5-49.719-.8-99.43-.079-12.091-.131-24.181a8,8,0,0,1,1.356,1.064,9.006,9.006,0,0,1,2.63,6.073l1.936,124.077a9.057,9.057,0,0,1-2.435,6.157Z",
    transform: "translate(-42.6 -3.033)",
    fill: "#232952",
    opacity: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1415",
    "data-name": "Path 1415",
    d: "M318.169,158.549c-1.989.714-3.81,1.454-5.447,2.174a7.1,7.1,0,0,0-3.278,2.2,8.975,8.975,0,0,0-1.831,3.529,9.982,9.982,0,0,0-.339,2.569l-.031,4.411a76.873,76.873,0,0,1-43.878,3.37,165.676,165.676,0,0,0,30.653-8.71,28.554,28.554,0,0,0,4.487-1.984c14.291-8.532,12.835-32.6,12.174-70.954-.22-12.871-.426-31.869-.228-55.479,1.991.413,3.862.851,5.615,1.293.077.012.167.032.263.052l1.838,117.525Z",
    transform: "translate(-37.461 -1.674)",
    fill: "#15192f",
    opacity: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1416",
    "data-name": "Path 1416",
    d: "M233.915,130.5q-.262-41.74-.523-83.478a99.756,99.756,0,0,1,10.052-2.738A102.1,102.1,0,0,1,276.3,42.641c-4.424.878-10.956,2.306-18.827,4.538-7.2,2.042-8.657,2.811-9.617,3.423-8.219,5.242-9.082,17.638-9.628,25.163-1.218,16.78-2.682,34.394-4.315,54.73Z",
    transform: "translate(-26.974 -2.488)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1417",
    "data-name": "Path 1417",
    d: "M230.026,186c-1.267-.413-2.469-.82-3.593-1.229a8.737,8.737,0,0,1-3.909-2.165,8.563,8.563,0,0,1-2.623-6.073L217.959,52.455a8.964,8.964,0,0,1,2.434-6.151,8.66,8.66,0,0,1,2.363-1.723c-.484,1.966-.98,4.289-1.4,6.9a86.178,86.178,0,0,0-1.081,14.7c.194,24.3.291,36.461.488,52.472.213,17.049,2.376,34.085,1.742,51.124a18.916,18.916,0,0,0,.709,6.134A21.253,21.253,0,0,0,230.026,186Z",
    transform: "translate(-21.574 -3.389)",
    fill: "#fff",
    opacity: 0.49
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1418",
    "data-name": "Path 1418",
    d: "M272.3,351.694a4.189,4.189,0,0,1-3.377-4.673,4.178,4.178,0,0,1,1.705-2.865,4.078,4.078,0,0,1,2.217-.648,6.609,6.609,0,0,1,4.673,2.149,21.533,21.533,0,0,1,1.394,1.649c.5.646.666.921.95,1.305a7.569,7.569,0,0,0,2.908,2.707,4.507,4.507,0,0,0,3.274.239,4.408,4.408,0,0,0,2.467-2.2,4.09,4.09,0,0,0,.385-2.841,3.9,3.9,0,0,0-.819-1.541,4.326,4.326,0,0,0-1.615-1.205,5.454,5.454,0,0,0-4.75.731,9.738,9.738,0,0,0-1.3,1.013c-.054.051-.1.092-.126.122a10.912,10.912,0,0,0-1.377,1.675c-.473.677-.553.9-.848,1.352a6.9,6.9,0,0,1-2.865,2.626,4.656,4.656,0,0,1-2.9.41Z",
    transform: "translate(-39.394 -107.977)",
    fill: "none",
    stroke: "#139093",
    strokeWidth: 4
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadingRobotLogo);
export default __webpack_public_path__ + "static/media/loading-robot_logo.39974ad529699a449eb5a3e7dbcaf94d.svg";
export { ForwardRef as ReactComponent };